import React from 'react';
import Layout from './Layout/Layout'
const Admin = () => {
    return (
        <div>
            <Layout></Layout>
        </div>
    );
};

export default Admin;